// quick-cart.js — Módulo de quick cart extraído de theme.js (v1.1.0)
// Carregado via snippets/global-script.liquid ENTRE global.js e theme.js (ambos defer).
// Executa ANTES do theme.js; em runtime o theme.js já mergeou seus helpers em window.halo.
(function ($) {
    var $body = $('body'),
        $doc = $(document);

    // Guard: helpers que ficaram no theme.js (showWarning, checkNeedToConvertCurrency,
    // buildScript, buildStyleSheet, updateCart) — só existem em runtime após theme.js carregar.
    function haloCall(name) {
        var fn = window.halo && window.halo[name];
        if (typeof fn === 'function') {
            return fn.apply(window.halo, Array.prototype.slice.call(arguments, 1));
        }
        return undefined;
    }

    function sharedAnimation(action) {
        if (window.sharedFunctionsAnimation && typeof window.sharedFunctionsAnimation[action] === 'function') {
            window.sharedFunctionsAnimation[action]();
        }
    }

    var quickCart = {
        initQuickCart: function() {
            if (window.quick_cart && window.quick_cart.show) {
                if (window.quick_cart.type == 'popup') {
                    // halo.initDropdownCart();
                } else {
                    quickCart.initSidebarCart();
                }
            }

            quickCart.initEventQuickCart();
        },

        initEventQuickCart: function(){
            quickCart.removeItemQuickCart();
            quickCart.updateQuantityItemQuickCart();
            // quickCart.editQuickCart();
        },

        productCollectionCartSlider: function(){
            var productCart = $('[data-product-collection-cart]');

            productCart.each((index, element) => {
                var self = $(element),
                    productGrid = self.find('.products-carousel'),
                    itemDots = productGrid.data('item-dots'),
                    itemArrows = productGrid.data('item-arrows');

                if(productGrid.length > 0){
                    if(!productGrid.hasClass('slick-initialized')){
                        productGrid.slick({
                            mobileFirst: true,
                            adaptiveHeight: false,
                            infinite: false,
                            vertical: false,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            arrows: false,
                            nextArrow: window.arrows.icon_next,
                            prevArrow: window.arrows.icon_prev,
                            rtl: window.rtl_slick,
                            responsive: [
                            {
                                breakpoint: 1025,
                                settings: {
                                    dots: itemDots,
                                    arrows: itemArrows
                                }
                            }]
                        });
                    }
                }
            });
        },

        initSidebarCart: function() {
            var cartIcon = $('[data-cart-sidebar]');
            let cartOpenRequest;
            cartIcon.on('click', () => {
                if (cartOpenRequest) return;
                cartOpenRequest = Shopify.getCart().then(cart => quickCart.updateSidebarCart(cart)).catch(() => {}).finally(() => { cartOpenRequest = null; });
                if ($('body').hasClass('cursor-fixed__show')){
                    sharedAnimation('onEnterButton');
                    sharedAnimation('onLeaveButton');
                }
            })
            if ($body.hasClass('template-cart')) {
                cartIcon.on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    $('html, body').animate({
                        scrollTop: 0
                    }, 700);
                });
                if (haloCall('checkNeedToConvertCurrency')) {
                  Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                };
            } else {
                cartIcon.on('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    
                    $body.addClass('cart-sidebar-show');
                });
            }

            $doc.on('click', '[data-close-cart-sidebar]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                if ($body.hasClass('cart-sidebar-show')) {
                    $body.removeClass('cart-sidebar-show');
                }
            });

            $body.on('click', '.background-overlay', (event) => {
                if ($body.hasClass('cart-sidebar-show') && !$body.hasClass('quickshop-popup-show') && !$body.hasClass('quick_shop_popup_mobile') && !$body.hasClass('edit-cart-show') && !$body.hasClass('term-condition-show') && !$body.hasClass('has-warning')) {
                    if (($(event.target).closest('#halo-cart-sidebar').length === 0) && 
                        ($(event.target).closest('[data-cart-sidebar]').length === 0) && 
                        ($(event.target).closest('[data-edit-cart-popup]').length === 0) && 
                        ($(event.target).closest('[data-warning-popup]').length === 0) && 
                        ($(event.target).closest('[data-term-condition-popup]').length === 0)){
                        $body.removeClass('cart-sidebar-show');
                    }
                }
            })
        },

        updateSidebarCart: function(cart) {
            if (!cart || !Array.isArray(cart.items)) return Promise.resolve(false);
            const $cartDropdown = $('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
            if (!$cartDropdown.length) return Promise.resolve(false);
            const sequence = (quickCart.refreshSequence || 0) + 1;
            quickCart.refreshSequence = sequence;
            const version = Shopify.cartVersion;
            if (quickCart.refreshController) quickCart.refreshController.abort();
            const controller = new AbortController();
            quickCart.refreshController = controller;
            const timeout = setTimeout(() => controller.abort(), 15000);
            $cartDropdown.addClass('is-loading').attr('aria-busy', 'true');
            $cartDropdown.find('.loading-overlay--custom').remove();
            $cartDropdown.prepend('<div class="loading-overlay loading-overlay--custom"><div class="loading-overlay__spinner"><svg aria-hidden="true" class="spinner" viewBox="0 0 66 66"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></div>');
            const request = fetch(Shopify.cartUrl('cart?view=ajax_side_cart'), {
                signal: controller.signal, credentials: 'same-origin', cache: 'no-store'
            }).then(response => {
                if (!response.ok) throw new Error('Falha ao carregar o carrinho.');
                return response.text();
            }).then(html => {
                if (sequence !== quickCart.refreshSequence || version !== Shopify.cartVersion) return false;
                const response = $(html);
                if (!response.filter('.previewCart').length && !response.find('.previewCart').length) throw new Error('Resposta incompleta do carrinho.');
                $cartDropdown.find('.recommend-slider').each((_, slider) => {
                    if (slider.swiper) slider.swiper.destroy(true, true);
                });
                $cartDropdown.html(response);
                Shopify.updateCartPendingControls();
                quickCart.dispatchChangeForShippingMessage();
                quickCart.productCollectionCartSlider();
                quickCart.updateGiftWrapper();
                if (haloCall('checkNeedToConvertCurrency')) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
                if ($body.hasClass('cursor-fixed__show')) {
                    sharedAnimation('onEnterButton');
                    sharedAnimation('onLeaveButton');
                }
                return true;
            }).catch(error => {
                if (sequence !== quickCart.refreshSequence) return false;
                Shopify.showCartError($cartDropdown[0], 'Não foi possível atualizar a visualização. Confira seu carrinho antes de repetir a compra.', { cartLink: true });
                throw error;
            }).finally(() => {
                clearTimeout(timeout);
                if (sequence !== quickCart.refreshSequence) return;
                $cartDropdown.removeClass('is-loading').removeAttr('aria-busy');
                $cartDropdown.find('.loading-overlay--custom').remove();
                if (version === Shopify.cartVersion) {
                    $body.find('[data-cart-count]').text(cart.item_count);
                    $body.find('[data-cart-text]').text(cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items);
                    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
                }
            });
            // Some legacy callers use callbacks only; the error is already visible in the drawer.
            request.catch(() => {});
            return request;
        },

        loadCartUpsell: function(container) {
            if (!container || container.dataset.upsellStarted) return;
            container.dataset.upsellStarted = 'true';
            // Recommendations never gate the cart controls or checkout.
            setTimeout(async () => {
                let seeds;
                try { seeds = JSON.parse(container.querySelector('[data-upsell-seeds]').textContent); }
                catch (_) { container.hidden = true; return; }
                const unique = Array.from(new Map(seeds.map(item => [item.product_id, item])).values()).slice(0, 3);
                if (!unique.length || !container.isConnected) return;
                const cache = quickCart.upsellCache || (quickCart.upsellCache = new Map());
                const read = async url => {
                    const controller = new AbortController();
                    const timeout = setTimeout(() => controller.abort(), 8000);
                    try {
                        const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
                        if (!response.ok) throw new Error('Recomendações indisponíveis.');
                        return await response.text();
                    } finally { clearTimeout(timeout); }
                };
                try {
                    if (!quickCart.upsellSectionPromise) {
                        quickCart.upsellSectionPromise = read(Shopify.cartUrl('products/' + encodeURIComponent(unique[0].handle) + '?view=recomendations')).then(html => {
                            const doc = new DOMParser().parseFromString(html, 'text/html');
                            const section = doc.querySelector('[id^="shopify-section-"]');
                            if (!section) throw new Error('Seção de recomendações indisponível.');
                            return section.id.replace('shopify-section-', '');
                        }).catch(error => { quickCart.upsellSectionPromise = null; throw error; });
                    }
                    const sectionId = await quickCart.upsellSectionPromise;
                    const results = await Promise.allSettled(unique.map(item => {
                        const key = sectionId + ':' + (seeds[0].variant_id || '') + ':' + item.product_id;
                        let entry = cache.get(key);
                        if (!entry || Date.now() - entry.time > 300000) {
                            const params = new URLSearchParams({ view: 'recomendations', section_id: sectionId, product_id: item.product_id, limit: 6 });
                            entry = { time: Date.now(), promise: read(Shopify.cartUrl('recommendations/products?') + params) };
                            cache.set(key, entry);
                            entry.promise.catch(() => cache.delete(key));
                            if (cache.size > 20) cache.delete(cache.keys().next().value);
                        }
                        return entry.promise;
                    }));
                    if (!container.isConnected) return;
                    const wrapper = container.querySelector('.swiper-wrapper');
                    const added = new Set(seeds.flatMap(item => [String(item.product_id), '/products/' + item.handle]));
                    let count = 0;
                    results.forEach(result => {
                        if (result.status !== 'fulfilled') return;
                        const doc = new DOMParser().parseFromString(result.value, 'text/html');
                        doc.querySelectorAll('.item-recommend').forEach(card => {
                            const product = card.querySelector('[data-product-id]');
                            const id = product ? product.getAttribute('data-product-id') : new URL(card.dataset.handle || card.querySelector('a[href]').getAttribute('href'), window.location.origin).pathname;
                            if (!id || added.has(id) || count >= 8) return;
                            added.add(id);
                            wrapper.appendChild(document.importNode(card, true));
                            count++;
                        });
                    });
                    if (!count) { container.hidden = true; return; }
                    container.hidden = false;
                    const SwiperClass = await quickCart.loadUpsellSwiper(container.dataset.swiperUrl);
                    if (!SwiperClass || !container.isConnected) return;
                    const slider = container.querySelector('.recommend-slider');
                    if (slider.swiper) { slider.swiper.update(); return; }
                    new SwiperClass(slider, {
                        slidesPerView: 'auto', spaceBetween: 15, slidesPerGroup: 3, freeMode: true,
                        navigation: { nextEl: slider.querySelector('.swiper-button-next'), prevEl: slider.querySelector('.swiper-button-prev') },
                        scrollbar: { el: slider.querySelector('.swiper-scrollbar'), draggable: true }
                    });
                    container.classList.remove('upsell-static');
                } catch (_) {
                    // Optional recommendations may fail without interrupting the purchase.
                    container.hidden = true;
                }
            }, 0);
        },

        loadUpsellSwiper: function(url) {
            if (window.Swiper) return Promise.resolve(window.Swiper);
            if (quickCart.upsellSwiperPromise) return quickCart.upsellSwiperPromise;
            quickCart.upsellSwiperPromise = new Promise(resolve => {
                const script = document.createElement('script');
                let settled = false;
                const finish = value => {
                    if (settled) return;
                    settled = true;
                    clearTimeout(timeout);
                    script.onload = script.onerror = null;
                    resolve(value);
                };
                const timeout = setTimeout(() => finish(null), 8000);
                script.src = url;
                script.async = true;
                script.onload = () => finish(window.Swiper || null);
                script.onerror = () => finish(null);
                document.head.appendChild(script);
            });
            return quickCart.upsellSwiperPromise;
        },

        dispatchChangeForShippingMessage: function() {
            document.querySelectorAll('[data-free-shipping-wrapper]').forEach(freeShippingWrapper => {
                const changeEvent = new Event('change', { bubbles: true })
                freeShippingWrapper.dispatchEvent(changeEvent);
            })
        },

        updateGiftWrapper: function() {
            let debounce 
            $('#gift-wrapping').off('click').on('click', (event) => {
                event.stopPropagation()
                event.preventDefault()
                const $target = $(event.currentTarget);
                clearTimeout(debounce)
                debounce = setTimeout(() => {
                    const variantId = event.target.dataset.giftId;
                    Shopify.addItem(variantId, 1, $target, () => {
                        Shopify.getCart((cart) => {
                            return quickCart.updateSidebarCart(cart);
                        });
                    }); 
                }, 250)
            });

            $('#cart-gift-wrapping').off('click').on('click', (event) => {
                event.stopPropagation()
                event.preventDefault()

                var $target = $(event.currentTarget),
                    text = $target.attr('data-adding-text');
                $target.text(text);

                clearTimeout(debounce)
                debounce = setTimeout(() => {
                    const variantId = event.target.dataset.giftId;
                    Shopify.addItem(variantId, 1, $target, () => {
                        Shopify.getCart((cart) => {
                            haloCall('updateCart', cart)
                        });
                    }); 
                }, 250)
            });
        },

        removeItemQuickCart: function () {
            $doc.on('click', '[data-cart-remove]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    productId = $target.attr('data-cart-remove-id'),
                    text = $('#cart-gift-wrapping').attr('data-add-text'),
                    productLine = $target.data('line'),
                    index = $target.data('index');

                $('#cart-gift-wrapping').text(text);

                Shopify.removeItem(productLine, index, (cart) => {
                    if($body.hasClass('template-cart')){
                        return haloCall('updateCart', cart);
                    } else if($body.hasClass('cart-modal-show')){
                        // halo.updateDropdownCart(cart);
                    } else if($body.hasClass('cart-sidebar-show')) {
                        return quickCart.updateSidebarCart(cart);
                    }
                });
            });
        },

        updateQuantityItemQuickCart: function(){
            $doc.on('change', '[data-cart-quantity]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    productId = $target.attr('data-cart-quantity-id'),
                    productLine = $target.data('line'),
                    quantity = parseInt($target.val()),
                    stock = parseInt($target.data('inventory-quantity')),
                    index = $target.data('index');
                let enoughInStock = true;
               
                if (stock < quantity && stock > 0) {
                  var arrayInVarName = `cart_selling_array_${event.currentTarget.closest('cart-update-quantity').dataset.product}`,
                    itemInArray = window[arrayInVarName],
                    itemStatus = itemInArray && itemInArray[event.currentTarget.closest('cart-update-quantity').dataset.variant];
                  if(itemStatus == 'deny') {
                    quantity = stock;
                    enoughInStock = false;
                  }
                }

                Shopify.changeItem(productLine, quantity, index, (cart) => {
                    if (!enoughInStock) haloCall('showWarning', window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', quantity));
                    if($body.hasClass('template-cart')){
                        return haloCall('updateCart', cart);
                    } else if($body.hasClass('cart-modal-show')){
                        // halo.updateDropdownCart(cart);
                    } else if($body.hasClass('cart-sidebar-show')) {
                        return quickCart.updateSidebarCart(cart);
                    }
                });
            });
        },

        editQuickCart: function() {
            let checkLoadEC = true; 

            $doc.on('click', '[data-open-edit-cart]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    url = $target.data('edit-cart-url'),
                    itemId = $target.data('edit-cart-id'),
                    itemLine = $target.data('line'),
                    itemIndex = $target.data('index'),
                    quantity = $target.data('edit-cart-quantity'),
                    option = $target.parents('.previewCartItem').find('previewCartItem-variant').text();

                const modal = $('[data-edit-cart-popup]'),
                    modalContent = modal.find('.halo-popup-content');

                if (checkLoadEC) {
                    checkLoadEC = false;
                    const $editCart = document.querySelector('.halo-edit-cart-popup');
                    const urlStyleEC = $editCart.dataset.urlStyleEditCart;
                    const urlScriptEC = $editCart.dataset.urlScriptEditCart;
    
                    haloCall('buildStyleSheet', urlStyleEC, $editCart);
                    haloCall('buildScript', urlScriptEC);
                }

                $.ajax({
                    type: 'get',
                    url: url,
                    cache: false,
                    dataType: 'html',
                    beforeSend: function() {
                        if($body.hasClass('template-cart')){
                            // halo.showLoading();
                        }
                    },
                    success: function(data) {
                        modalContent.html(data);
                        modalContent
                            .find('[data-template-cart-edit]')
                            .attr({
                                'data-cart-update-id': itemId,
                                'data-line': itemLine,
                                'data-index': itemIndex
                            });

                        var productItem = modalContent.find('.product-edit-item');
                        productItem.find('input[name="quantity"]').val(quantity);
                    },
                    error: function(xhr, text) {
                        // alert($.parseJSON(xhr.responseText).description);
                        haloCall('showWarning', $.parseJSON(xhr.responseText).description);
                        if($body.hasClass('template-cart')){
                            // halo.hideLoading();
                        }
                    },
                    complete: function () {
                        $body.addClass('edit-cart-show');

                        if($body.hasClass('template-cart')){
                            // halo.hideLoading();
                        }

                        if (haloCall('checkNeedToConvertCurrency')) {
                            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        };

                        if ($('body').hasClass('cursor-fixed__show')){
                            sharedAnimation('onEnterButton');
                            sharedAnimation('onLeaveButton');
                        }
                    }
                });
            });

            $doc.on('click', '[data-close-edit-cart]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                $body.removeClass('edit-cart-show');
            });

            $doc.on('click', (event) => {
                if ($body.hasClass('edit-cart-show')) {
                    if (($(event.target).closest('[data-edit-cart-popup]').length === 0) && ($(event.target).closest('[data-open-edit-cart]').length === 0)){
                        $body.removeClass('edit-cart-show');
                    }
                }
            });

            quickCart.addMoreItemEditCart();
            quickCart.addAllItemCartEdit();
        },

        addMoreItemEditCart: function(){
            $doc.on('click', '[data-edit-cart-add-more]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var itemWrapper = $('[data-template-cart-edit]'),
                    currentItem = $(event.target).parents('.product-edit-item'),
                    count = parseInt(itemWrapper.attr('data-count')),
                    cloneProduct = currentItem.clone().removeClass('product-edit-itemFirst');
                    cloneProductId = cloneProduct.attr('id') + count;

                cloneProduct.attr('id', cloneProductId);

                quickCart.updateClonedProductAttributes(cloneProduct, count);

                cloneProduct.insertAfter(currentItem);

                count = count + 1;
                itemWrapper.attr('data-count', count);

                if ($('body').hasClass('cursor-fixed__show')){
                    sharedAnimation('onEnterButton');
                    sharedAnimation('onLeaveButton');
                }
            });

            $doc.on('click', '[data-edit-cart-remove]', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var currentItem = $(event.target).parents('.product-edit-item');

                currentItem.remove();
            });
        },

        updateClonedProductAttributes: function(product, count){
            var form = $('.shopify-product-form', product),
                formId = form.attr('id'),
                newFormId = formId + count;

            form.attr('id', newFormId);

            $('.product-form__radio', product).each((index, element) => {
                var formInput = $(element),
                    formLabel = formInput.next(),
                    id = formLabel.attr('for'),
                    newId = id + count,
                    formInputName = formInput.attr('name');

                formLabel.attr('for', newId);

                formInput.attr({
                    id: newId,
                    name: formInputName + count
                });
            });
        },

        addAllItemCartEdit: function() {
            $doc.on('click', '#add-all-to-cart', (event) => {
                event.preventDefault();
                event.stopPropagation();

                var $target = $(event.currentTarget),
                    cartEdit = $('[data-template-cart-edit]'),
                    product = cartEdit.find('.product-edit-item.isChecked'),
                    productId = cartEdit.attr('data-cart-update-id'),
                    productLine = cartEdit.data('line'),
                    index = cartEdit.data('index');

                if(product.length > 0){
                    $target.addClass('is-loading');

                    Shopify.removeItem(productLine, index, (cart) => {
                        if(!$.isEmptyObject(cart)) {
                            var productHandleQueue = [];

                            var ajax_caller = function(data) {
                                return $.ajax(data);
                            }

                            product.each((index, element) => {
                                var item = $(element),
                                    variantId = item.find('input[name="id"]').val(),
                                    qty = parseInt(item.find('input[name="quantity"]').val());

                                productHandleQueue.push(ajax_caller({
                                    type: 'post',
                                    url: window.routes.root + '/cart/add.js',
                                    data: 'quantity=' + qty + '&id=' + variantId,
                                    dataType: 'json',
                                    async: false
                                }));
                            });

                            if(productHandleQueue.length > 0) {
                                $.when.apply($, productHandleQueue).done((event) => {
                                    setTimeout(function(){ 
                                        $target.removeClass('is-loading');
                                    }, 1000);

                                    Shopify.getCart((cart) => {
                                        $body.removeClass('edit-cart-show');

                                        if($body.hasClass('template-cart')){
                                            return haloCall('updateCart', cart);
                                        } else if($body.hasClass('cart-modal-show')){
                                            // halo.updateDropdownCart(cart);
                                        } else if($body.hasClass('cart-sidebar-show')) {
                                            return quickCart.updateSidebarCart(cart);
                                        }
                                    });
                                });
                            }
                        }
                    });
                } else {
                    alert(window.variantStrings.addToCart_message);
                }
            });
        }
    };

    // theme.js não chama mais initQuickCart; auto-init IMEDIATO aqui.
    // Defer executa após o parse completo do DOM → [data-cart-sidebar] já existe.
    // jQuery (bloqueante) e global.js (defer anterior) já carregaram; window.quick_cart
    // e rotas vieram do inline script de global-script.liquid (roda durante o parse).
    // O carrinho fica clicável ANTES do theme.js terminar de executar.
    // Guards haloCall/Currency/sharedAnimation cobrem helpers do theme.js ainda não mergeados.
    quickCart.initQuickCart();

    window.halo = Object.assign(window.halo || {}, quickCart);
})(jQuery);